import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * 見つからないページ。
 *
 * これが無かったため、少しでもURLが違うと画面が真っ白になり、
 * 何が起きたのか分からないまま「バグだらけ」に見えていた。
 * どこへ行こうとしたのかと、戻り先を必ず出す。
 */
const NotFound: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 6 }}>
      <Paper sx={{ p: 4, maxWidth: 560, width: '100%' }}>
        <Stack spacing={2} alignItems="flex-start">
          <SearchOffIcon sx={{ fontSize: 44, color: 'text.disabled' }} />
          <Typography variant="h5" fontWeight="bold">
            このページは見つかりませんでした
          </Typography>
          <Typography variant="body2" color="text.secondary">
            指定されたアドレスに対応する画面がありません。
            古いブックマークか、リンクの打ち間違いの可能性があります。
          </Typography>
          <Box sx={{ bgcolor: 'grey.100', p: 1.5, borderRadius: 1, width: '100%' }}>
            <Typography variant="caption" color="text.secondary">開こうとしたアドレス</Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>
              {location.pathname}
            </Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <Button variant="contained" onClick={() => navigate('/dashboard')}>
              ダッシュボードへ
            </Button>
            <Button onClick={() => navigate(-1)}>前の画面に戻る</Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default NotFound;
